/**
 * 강화 재료 인벤토리 — 범용 강화석 보관 (지시문 §7·§13). 다이아 상자가 강화석을 지급하고,
 * 인벤토리 탭에서 강화석 + 골드로 ModuleInstance를 강화한다. 순수 로직 (Phaser 비의존, 테스트 대상).
 */
export interface UpgradeInventoryState {
  readonly universalUpgradeStone: number;
}

export class UpgradeInventory {
  private _stone: number;

  constructor(initialStone = 0) {
    this._stone = Math.max(0, Math.floor(initialStone));
  }

  get universalUpgradeStone(): number {
    return this._stone;
  }

  addStone(amount: number): void {
    if (amount <= 0) return;
    this._stone += Math.floor(amount);
  }

  /** 비용만큼 차감 시도. 충분하면 차감 + true, 부족하면 무변경 + false (EconomyController.trySpend 패턴). */
  trySpendStone(cost: number): boolean {
    const c = Math.max(0, Math.floor(cost));
    if (this._stone < c) return false;
    this._stone -= c;
    return true;
  }

  /** 치트/직접 설정용. */
  setStone(amount: number): void {
    this._stone = Math.max(0, Math.floor(amount));
  }

  toState(): UpgradeInventoryState {
    return { universalUpgradeStone: this._stone };
  }

  static fromState(state: UpgradeInventoryState): UpgradeInventory {
    return new UpgradeInventory(state.universalUpgradeStone);
  }
}
